import { render, staticRenderFns } from "./NerisForm.vue?vue&type=template&id=225e5f08&"
import script from "./NerisForm.vue?vue&type=script&lang=js&"
export * from "./NerisForm.vue?vue&type=script&lang=js&"
import style0 from "./NerisForm.vue?vue&type=style&index=0&id=225e5f08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports